import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

/**
 * Wraps routes restreintes pour les comptes en essai gratuit (#101).
 * - Pas de token: laisse passer (lecture publique anonyme)
 * - Trial user (package.is_test=true): redirige vers /dashboard/subscription
 * - User payant: laisse passer
 */
export default function TrialContentGuard({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [state, setState] = useState<'loading' | 'allowed' | 'blocked'>('loading');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setState('allowed');
      return;
    }
    api.get('/user/profile/me')
      .then((res) => {
        const isTrial = !!res.data?.package?.is_test;
        setState(isTrial ? 'blocked' : 'allowed');
      })
      .catch(() => setState('allowed')); // si l'API fail, on ne bloque pas
  }, [location.pathname]);

  if (state === 'loading') return null;
  if (state === 'blocked') {
    return (
      <Navigate
        to={`/${i18n.language}/dashboard/subscription`}
        replace
        state={{ trialBlocked: true }}
      />
    );
  }
  return <>{children}</>;
}
